<template>
    <div class="deal_refund_box">
			<!-- 設定API金錀 -->
			<div class="set_box" v-show="setTF">
				<div class="set_api_back">
				</div>
				<div class="set_api">
                    <div class="set_api_title">
                        設定API金錀
                        <i @click="closeFun()" class="iconfont">&#xe62d;</i>
                    </div>
                    <!-- 步驟1 -->
                    <div class="set_api_content" v-show="setNextTF">
                        <div class="content_left">
                            <img src="@/assets/img/user/12api_safety_alert.png" alt="">
                        </div>
                        <div class="content_right">
                            <p>
                                設定修改API金錀可能會影響線上交易，若非金鑰洩露，建議不要隨意修改API金鑰！
                            </p>
                            <div class="key_input_box">
                                <el-input v-model="keyInput" placeholder="請輸入大寫 YES 生成新的金鑰"></el-input>
                            </div>
                            <div class="key_button_box">
                                <el-button plain @click="setKey()">取消</el-button>
                                <el-button type="primary" @click='Submission()'>確認</el-button>
                            </div>
                        </div>
                    </div>
                    <!-- 步驟2 -->
                    <div class="set_api_content" v-show="!setNextTF">
                        <div class="content_next">
                            <div>商家名稱：{{this.$store.state.storename}}</div>
                            <div>商家編號：{{this.$store.state.uid}}</div>
                            <div>
                                API金鑰：
                                    <el-input v-model="api" placeholder=""></el-input>
                                <el-button type="primary" @click="copy()">複製金鑰</el-button>
                            </div>
                            <div>舊金鑰已失效，請複製該金鑰至本機</div>
                        </div>
                    </div>
                </div>
			</div>
        <!-- API安全 -->
        <div class="deal_title">
            <div>帳戶設定<span>》</span>API安全</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- BOX-go -->
        <div>
            <!-- 内容-1-API金錀 -->
            <div class="deal_content_box">
                <div class="deal_content_title">API金錀</div>
                <div class="deal_content">
					<!-- 1 -->
					<div class="remind_box">
						<i class="el-icon-warning icon_warning"></i>
						API金錀屬於敏感資訊，請妥善保管不要洩露，如果懷疑資訊洩露，請重設金錀。
                    </div>
					<div class="pass_box">
						請輸入<span class="pass_red">交易</span>密碼：<el-input class="pass_input" placeholder="請輸入交易密碼" v-model="trader_password" show-password></el-input> <span class="pass_blue" @click="forget()">忘記交易密碼？</span>
					</div>
					<div>
						<el-button class="pass_button" type="primary" @click="setKey()">設定金錀</el-button>
					</div>
                </div>
            </div>
             <!-- 内容-2-收付API安全 -->
            <div class="deal_content_box">
                <div class="deal_content_title">收付API安全</div>
                <div class="deal_content">
                    <div>
                        <el-checkbox v-model="checked" :disabled="true" >僅允許下列IP伺服務器調用API</el-checkbox>
                    </div>
                    <div class="form_table" >
                        <!-- 表單頭 -->
                        <div class="form_table_header">
                            <span>提交時間</span>
                            <span>IP</span>
                            <span>狀態</span>
                            <span>生效時間</span>
							<span>禁用IP</span>
                        </div>

                        <div class="form_table_content" v-for="item of tableData" :key="item.id">
                            <span>{{item.time}}</span>
                            <span>{{item.ip}}</span>
                            <span>{{statusJudge(item.del_status, item.sh_status)}}</span>
                            <span>{{item.shtime}}</span>
							<el-checkbox v-model="item.kong" @change='handcheckbox(item.del_status,item.id)' >禁用</el-checkbox>
                        </div>
                        <!-- 表單頭-end -->
                    </div>
                    <div>
                        <el-input class="pass_input" v-model="inputIP" placeholder=""></el-input>
                        <el-button class="button_add button_margin" plain @click="setadd()">新增IP</el-button>
                        <el-button class="button_add" type="primary" @click="buttonAddFun()">儲存</el-button>
                        <div class="hint_text">
                            <span v-show="hintTF">{{hintText}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- BOX-end -->
        </div>
        <!-- deal_refund_box -->
    </div>
</template>

<script>
	import axios from 'axios';
export default {
    name: 'LoginBapi',
    data() {
        return {
            userForm: {
                user: '這個歌簡稱',
                number: '1424524'
            },
            tableData:[],
            forbiddenId: [],
            trader_password: '',
            checked: true,
            inputIP: '',
            hintTF: true,
            hintText: '最多只能設定5組IP！',
            // false
            setTF: false,
            keyInput: '',
            setNextTF: true,
            api: 'xxdadadwadfxadgafaafa',
            bbb: true
        }
    },
    methods: {
        forget() {
            this.$router.push("/forget");
        },
        // 关闭金钥
        closeFun(){
            this.setTF = !this.setTF;
            if(!this.setNextTF){
                this.setNextTF = true;
                this.keyInput = '';
            }
        },
		// 設定金輪
        setKey(){
			if(this.trader_password===''){
				this.$message({
					showClose: true,
					message: '请输入交易密碼',
					type: 'error',
					duration: 1000
				});
				return
			}else if(this.verification(this.trader_password)){
				this.$message({
					showClose: true,
					message: '交易密碼為純數字',
					type: 'error',
					duration: 1000
				});
				return
			}
			axios.get(this.$store.state.axiossubmitsafet, {
				params: {
					uid: this.$store.state.uid,
					trader_password: this.trader_password,
	                action:1
				}
			}).then((res) => {
				// console.log(res)
					this.message = res.data.message;
					this.status = res.data.status;
					// 修改失敗
					if (!this.status){
							this.$message({
								showClose: true,
								message: this.message,
								type: 'error',
								duration: 1000
							});
					}else{
						this.setTF = !this.setTF
					}	
			})   
        },
        // 啟用和禁用
        disableFun(index){
            if( index == '1'){
                return true
            } else {
                return false
            }
        },
		// 設定金輪提交確認
		Submission(){
			if(this.keyInput=='YES'){
				axios.get(this.$store.state.axiosapigenerate, {
					params: {
						uid: this.$store.state.uid,
				        action:1
					}
				}).then((res) => {
					// console.log(res.data);
                    this.api = res.data.message.api;
                    this.status = res.data.status;
                    // 修改失敗
                    if (!this.status){
                            this.$message({
                                showClose: true,
                                message: this.message,
                                type: 'error',
                                duration: 1000
                            });
                    }else{
                        this.setNextTF = !this.setNextTF
                    }	
				})
			}else{
                // this.setTF = !this.setTF
                this.$message({
					showClose: true,
					message: '请输入大寫 YES',
					type: 'error',
					duration: 1000
				});
			}
			
			
			
		},
		copy(){
			var Url2 = this.api;
			  var oInput = document.createElement("input");
			  oInput.value = Url2;
			  document.body.appendChild(oInput);
			  oInput.select(); // 选择对象
			  document.execCommand("Copy"); // 执行浏览器复制命令
			  oInput.className = "oInput";
			  oInput.style.display = "none";
			  this.$message({
			 	showClose: true,
			 	message: '複製成功',
			 	type: 'success',
			 	duration: 1000
			 });
		},
		handcheckbox(val,id){
            // console.log(val,id);
			
        },
        // 儲存提交
        buttonAddFun(){
            this.forbiddenId = [];
            this.tableData.forEach((item, index)=>{
                if(item.kong == true){
                   this.forbiddenId.push(item.id);
                }
            })
            // console.log( this.forbiddenId);
			axios.get(this.$store.state.axiosforbidden, {
				params: {
					uid:this.$store.state.uid,
					id: this.forbiddenId,
				}
			}).then((res) => {
                // console.log(res.data);

                if(res.data.status){
                    this.tableDataFun(res.data.message);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error',
                        duration: 1000
                    });
                }
            })
        },
        // 狀態判斷
        statusJudge(del, sh){
            if(del == '0'){
                return '未生效/待系統設定 '
            } 
            if(del == '1'){
                if(sh == '1'){
                    return '已禁用/系統設定完畢'
                } else if(sh == '0'){
                    return '将禁用/待系統設定'
                } else {
                    return '未知错误'
                }
            }
            if(del == '2'){
                if(sh == '2'){
                    return '已啟用/系統設定完畢'
                } else if(sh == '0'){
                    return '将重新啟用/待系統設定'
                } else {
                    return '未知错误'
                }
            }
        },
		// 新增ip
		setadd(){
			if(this.inputIP==''){
				this.$message({
					showClose: true,
					message: '請輸入IP',
					type: 'error',
					duration: 1000
				});
				return
            }
            let pattern = /(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)/;
            if (!pattern.test(this.inputIP)) {
				this.$message({
					showClose: true,
					message: '請輸入正确的IP地址',
					type: 'error',
					duration: 1000
				});
                return
            }

			axios.get(this.$store.state.axiossubmitstanadd, {
				params: {
					uid:this.$store.state.uid,
					ip: this.inputIP,
		            action:1
				}
			}).then((res) => {
				// console.log(res)
					this.status = res.data.status;
					// 修改失敗
					if (!this.status){			
						this.message = res.data.message;
							this.$message({
								showClose: true,
								message: this.message,
								type: 'error',
								duration: 1000
							});
						
					}else{
                        this.tableData = res.data.message;
                        this.tableData.forEach((item, index)=>{
                            if(item.del_status == '1'){
                                item.kong = true
                            } else {
                                item.kong = false
                            }
                        })
					}
					
					
			})
		    
		},
		// 限制交易密码
		verification(str) {
			var pattern = /\D/;
			if (!pattern.test(str)) {
				return false;
			} else {
				return true;
			}
			
        },
        // 加工数据
        tableDataFun(data){
            data.forEach((item, index)=>{
                if(item.del_status == '1'){
                    item.kong = true
                } else {
                    item.kong = false
                }
            });
            this.tableData = data;
        },
    },

	mounted() {
		// 頁面加載讀取表單
		axios.get(this.$store.state.axiossubmitstanadd, {
			params: {
				action: 1,
				uid: this.$store.state.uid,
			}
		}).then((res) => {
            // console.log(res.data.message);
            this.tableData = res.data.message;
            // this.tableData.forEach((item, index)=>{
            //     if(item.del_status == '0'){
            //         // item.push('status_text') = '未生效/待系統設定';
            //     } else {
            //         item.del_status = false
            //     }
            // })
            this.tableData.forEach((item, index)=>{
                if(item.del_status == '1'){
                    item.kong = true
                } else {
                    item.kong = false
                }
            })
            // console.log('------------------');
            // console.log(this.tableData);
            // console.log(this.tableData);
		    // for(var i=0;i<this.tableData.lenght;i++){
			// 	if(this.tableData.del_status[i]==1){
			// 		this.tableData.del_status[i]=true
			// 		// console.log(this.tableData)
			// 	}else{
			// 		this.tableData.del_status[i]=false
			// 	}
			// }
	
		})
	
	
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 設定API */
    .set_api_back {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: black;
        overflow: hidden;
        opacity: 0.2;
        z-index: 4;
    }
    .set_api {
        position: absolute;
        left: 50%;
        top: 30%;
        margin-left: -260px;
        width: 520px;
        overflow: hidden;
        z-index: 10;
        border: 1px solid #5c595e;
    }
    .set_api_title {
        color: white;
        font-weight: bold;
        letter-spacing: 1px;
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        background: #e94068;
    }
    .set_api_title .iconfont {
        float: right;
        cursor: pointer;
    }
    .set_api_content {
        background: white;
        height: 200px;
        padding: 30px 50px;
        display: flex;
    }
    .content_left {
        width: 42px;
        padding-right: 18px;
        margin-top: 7px;
    }
    .content_right {

    }
    .content_right > p {
        font-weight: bold;
        line-height: 29px;
    }
    .key_input_box {
        margin: 20px 0 30px;
    }
    .key_input_box .el-input {
        width: 340px;
    }
    .key_button_box {
        display: flex;
        justify-content: space-between;
        padding-right: 20px;
    }
    .key_button_box .el-button {
        width: 140px;
    }
    .content_next > div {
        margin: 10px 0;
        
    }
    .content_next .el-input {
        width: 250px;
        margin-right: 4px;
    }
    .content_next .el-button {
        padding: 10px;
    }
/* API安全 */
    .input_box {
        width: 100px;
    }
    .textarea_box {
        width: 350px;
        margin-left: 10px;
    }
    .input_pass {
        width: 350px;
    }
    .input_pass_number {
        cursor: pointer;
        margin-left: 10px;
        color: #4d80e7;
    }
    .el-input__inner {
        height: 20px;
    }
    .deal_refund_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        margin: 30px 30px 30px 0;
        display: flex;
        justify-content: flex-start;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
        font-weight: 700;
    }
    .deal_content {
        box-sizing: border-box;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 5px 25px;
    }
    .deal_content > div {
        margin: 22px 0;
    }
    .deal_content > div > .left_span {
        margin-left: 68px;
    }
    .deal_content .money_box {
        margin-top: 22px;
        margin-left: 114px;
    }
    .deal_content .money_box span {
        padding: 0 20px;
    }
    .deal_content .money_box span+span {
        border-left: 1px solid ;
    }
    .refund_money {
        margin-left: 28px;
        margin-right: 20px;
    }
    .money_button {
        font-size: 11px;
        line-height: 11px;
        padding: 6px 14px;
    }
    .money_number {
        margin-left: 16px;
    }
    .money_number > span {
        color: #6ac259;
    }
    .textarea_dis {
        display: flex;
        justify-content: flex-start;
    }
    .hint {
        margin-left: 10px;
        margin-top: 8px;
        font-size: 9px;
        color: #666666;
    }
	/* 提示 */
	  .remind_box {
			background: #fff4cc;
			color: black;
			width: 70%;
			min-width: 686px;
			height: 50px;
			display: flex;
			align-items: center;
			margin-bottom: 30px;
			margin-left: -6px;
    }
		.icon_warning {
			font-size: 22px;
			color: #ff4a05;
			padding: 0 6px 0 24px;
    }
		.pass_box {
			/* letter-spacing: 1px; */
		} 
		.pass_box .pass_red {
			color: #e73262;
		}
		.pass_input {
			width: 280px;
		}
		.pass_box .pass_blue {
			color: #4d80e7;
			margin-left: 10px;
			cursor: pointer;
		}
		.pass_button {
			padding: 8px;
		}
/*  */
		.form_table_header {
			background: #f2f2f2;
			height: 34px;
			line-height: 34px;
			overflow: hidden;
		}
		.form_table_content {
			height: 34px;
			line-height: 34px;
		}
		.form_table_header span, .form_table_content span	{
			display: inline-block;
			padding-left: 20px; 
			width: 300px;
		}
		.button_add {
			width: 100px;
		}
		.button_margin {
			margin-left: 4px;
			margin-right: 30px;
		}
		.hint_text {
			color: #e73262;
			margin-top: 6px;
			height: 8px;
        }
</style>
